import axios from 'axios'
import config from './config'
let mode = process.env.VUE_APP_NODE_ENV
let baseUrl = mode === 'development' ? process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT : process.env.VUE_APP_HTTP + '://' + config.origin
let fileviewuserUrl = mode === 'development' ? process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT + '/wopi-view-user-file' : 'https://' + process.env.VUE_APP_URL + '/wopi-view-user-file'
let fileviewUrl = mode === 'development' ? process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT + '/wopi-view' : 'https://' + process.env.VUE_APP_URL + '/wopi-view'
let fileeditUrl = mode === 'development' ? process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT + '/wopi-edit' : 'https://' + process.env.VUE_APP_URL + '/wopi-edit'
let groupfileviewUrl = mode === 'development' ? process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT + '/wopi-group-file-view' : 'https://' + process.env.VUE_APP_URL + '/wopi-group-file-view/'
let groupfileeditUrl = mode === 'development' ? process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT + '/wopi-group-file-edit' : 'https://' + process.env.VUE_APP_URL + '/wopi-group-file-edit/'

let publicfileviewUrl = mode === 'development' ? process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT + '/wopi-public-file-view' : 'https://' + process.env.VUE_APP_URL + '/wopi-public-file-view/'
let publicfileeditUrl = mode === 'development' ? process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT + '/wopi-public-file-edit' : 'https://' + process.env.VUE_APP_URL + '/wopi-public-file-edit/'

let sharedfileviewUrl = mode === 'development' ? process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT + '/wopi-shared-file-view' : 'https://' + process.env.VUE_APP_URL + '/wopi-shared-file-view/'
let sharedfileeditUrl = mode === 'development' ? process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT + '/wopi-shared-file-edit' : 'https://' + process.env.VUE_APP_URL + '/wopi-shared-file-edit/'

let viewDocUrl = mode === 'development' ? process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT + '/wopi-shared-link-view' : 'https://' + process.env.VUE_APP_URL + '/wopi-shared-link-view/'

let viewUrl = mode === 'development' ? process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT + '/view-file' : 'https://' + process.env.VUE_APP_URL + '/view-file/'

export default function () {
  return axios.create({
    baseURL: baseUrl,
    withCredentials: true
  })
}

export const download = url => {
  return axios({
    url: baseUrl + url,
    method: 'GET',
    responseType: 'blob'
  })
}

export const upload = () => {
  return axios.create({
    url: baseUrl,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const getCountry = (url) => {
  return axios({
    url: url,
    method: 'GET'
  })
}

export const getPrices = (url) => {
  return axios({
    url: baseUrl + '/' + url,
    method: 'POST'
  })
}

export const getfileinfo = (data) => {
  return axios({
    data: data,
    url: fileviewUrl,
    method: 'POST'
  })
}

export const viewfile = (data) => {
  return axios({
    data: data,
    url: viewUrl,
    method: 'POST'
  })
}

export const getfileviewdocinfo = (data) => {
  return axios({
    data: data,
    url: viewDocUrl,
    method: 'POST'
  })
}

export const getfileviewuserinfo = (data) => {
  return axios({
    data: data,
    url: fileviewuserUrl,
    method: 'POST'
  })
}

export const getfileviewinfo = (data) => {
  return axios({
    data: data,
    url: fileviewUrl,
    method: 'POST'
  })
}

export const getfileeditinfo = (data) => {
  return axios({
    data: data,
    url: fileeditUrl,
    method: 'POST'
  })
}

export const getgroupfileviewinfo = (data) => {
  return axios({
    data: data,
    url: groupfileviewUrl,
    method: 'POST'
  })
}

export const getgroupfileeditinfo = (data) => {
  return axios({
    data: data,
    url: groupfileeditUrl,
    method: 'POST'
  })
}

export const getpublicfileviewinfo = (data) => {
  return axios({
    data: data,
    url: publicfileviewUrl,
    method: 'POST'
  })
}

export const getpublicfileeditinfo = (data) => {
  return axios({
    data: data,
    url: publicfileeditUrl,
    method: 'POST'
  })
}

export const getsharedfileviewinfo = (data) => {
  return axios({
    data: data,
    url: sharedfileviewUrl,
    method: 'POST'
  })
}

export const getsharedfileeditinfo = (data) => {
  return axios({
    data: data,
    url: sharedfileeditUrl,
    method: 'POST'
  })
}
